/**
 * CoureHub.Broadcast.Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface BroadcastMessage { 
    id?: string;
    serviceProviderId?: string;
    senderId?: string;
    phoneNumbers?: string;
    textMessage?: string;
    smsRoute?: string;
    addressbookId?: string;
    country?: string;
    scheduleTime?: Date;
    referenceNumber?: string;
    deliveryStatus?: number;
    messageType?: number;
    messageDeliveryId?: string;
    smsChannel?: number;
    dateModified?: Date;
    dateCreated?: Date;
}